// 商品中心的一些常用参数
import EVENTNAMES from "./event-names.js";
import store from '@/store/index';
import { BtnPowerConsts, CheckPower } from '@/utils/powerConsts.js'
import { stockUploadDropdownList } from "./utils/mixins.js";
export const PLATFORMS = ['kuaishou', 'fxg', 'pdd', 'jd', 'tb', 'alibaba','tjb', 'yz', 'wxsph', 'wxxd', 'tm', 'xhs', 'xy', 'pddtemu','shein','jdms','yyjk']

export const DISTRIBUTION_BTNS_LIST = () => {
  const UserBtnPowerConsts = store.getters.userBtnPowerConsts;
  const hasPublishPower = CheckPower(UserBtnPowerConsts.PROD_CENTER_PUBLIC_GOODS);
  let btnList = [
    { text: "批量铺货", eventName: EVENTNAMES["批量铺货"], visible: hasPublishPower },
    {
      text: "更新铺货",
      eventName: EVENTNAMES["更新铺货"],
      tooltip: "用于更新平台店铺已有的商品信息",
      visible: hasPublishPower,
    },
    {
      text: "组合铺货",
      dropList: [
        { text: "直接组合铺货", eventName: EVENTNAMES["直接组合铺货"], tooltip: "用于将多个商品组合上架到一个款上面", visible: hasPublishPower },
        { text: "加入购物车后铺货", eventName: EVENTNAMES["加入购物车后铺货"], tooltip: "将商品加入购物车后再进行组合铺货，支持跨页选款", visible: hasPublishPower },
      ],
      visible: hasPublishPower,
    },
    {
      text: "AI生成资料",
      dropList: [
        { text: "生成抖音资料", eventName: EVENTNAMES["一键生成平台资料"], config: { platform: 'fxg' }},
        { text: "生成1688资料", eventName: EVENTNAMES["一键生成平台资料"], config: { platform: '1688' } },
        { text: "生成拼多多资料", eventName: EVENTNAMES["一键生成平台资料"], config: { platform: 'pdd' } },
        { text: "生成淘宝资料", eventName: EVENTNAMES["一键生成平台资料"], config: { platform: 'tb' } },
        { text: "生成快手资料", eventName: EVENTNAMES["一键生成平台资料"], config: { platform: 'kuaishou' } },
        { text: "生成天猫资料", eventName: EVENTNAMES["一键生成平台资料"], config: { platform: 'tm' } },
        { text: "生成微信小店（视频号）资料", eventName: EVENTNAMES["一键生成平台资料"], config: { platform: 'wxsph' } },
        { text: "生成京东资料", eventName: EVENTNAMES["一键生成平台资料"], config: { platform: 'jd' } },
        { text: "生成小红书资料", eventName: EVENTNAMES["一键生成平台资料"], config: { platform: 'xhs' } },
        { text: "生成闲鱼资料", eventName: EVENTNAMES["一键生成平台资料"], config: { platform: 'xy' } },
        { text: "生成Temu资料", eventName: EVENTNAMES["一键生成平台资料"], config: { platform: 'pddtemu' } },
      ],
    },
    {
      text: "批量下架",
      eventName: EVENTNAMES["批量下架"],
      // tooltip: "用于将多个商品组合上架到一个款上面",
      visible: CheckPower(UserBtnPowerConsts.PROD_CENTER_BATCH_DELISTING),
    },
    {
      text: "新增商品",
      dropList: [
        { text: "从平台店铺下载", eventName: EVENTNAMES["从平台店铺下载"] },
        { text: "从快麦ERP导入", eventName: EVENTNAMES["从快麦ERP导入"] },
        { text: "手工新增商品", eventName: EVENTNAMES["手工新增商品"] },
        // {text: 'excel导入商品', eventName: EVENTNAMES['excel导入商品']}
      ],
      visible: CheckPower(UserBtnPowerConsts.PROD_CENTER_ADD),
    },
    {
      text: "批量操作",
      dropList: [
        { text: "修改销售价", eventName: EVENTNAMES["修改销售价"] },
        { text: "修改市场价", eventName: EVENTNAMES["修改市场价"] },
        { text: "修改类目和属性", eventName: EVENTNAMES["修改类目和属性"] },
        { text: "修改库存", eventName: EVENTNAMES["修改库存"] },
        { text: "修改重量", eventName: EVENTNAMES["修改重量"] },
        { text: "修改商品名称", eventName: EVENTNAMES["修改商品名称"] },
        { text: "修改绑定关系", eventName: EVENTNAMES["修改绑定关系"], tooltip: '勾选商品，手动修改快麦通商品和ERP商品的关联关系' },
        { text: "读取对应表关系", eventName: EVENTNAMES["读取对应表关系"], tooltip: '勾选商品，从平台下载的快麦通商品，获取对应表的关联关系作为快麦通商品和ERP商品的关联关系' },
        { text: "批量设置商品标签", eventName: EVENTNAMES["批量设置商品标签"] },
        { text: "批量关联素材包", eventName: EVENTNAMES["批量关联素材包"] },
        { text: "批量解除关联", eventName: EVENTNAMES["批量解除关联"] },
      ],
      visible: CheckPower(UserBtnPowerConsts.PROD_CENTER_EDIT),
    },
    { text: "删除商品", eventName: EVENTNAMES["删除商品"], visible: CheckPower(UserBtnPowerConsts.PROD_CENTER_DELETE) },
    {
      text: "批量更新资料",
      dropList: [
        // CheckPower(BtnPowerConsts.BATCHSYNCTOERP) ? { text: "批量同步快麦通资料到ERP资料", eventName: EVENTNAMES["批量同步快麦通资料到ERP资料"] } : null,
        { text: "批量同步快麦通资料到ERP资料", eventName: EVENTNAMES["批量同步快麦通资料到ERP资料"] },
        { text: "批量同步ERP资料到快麦通资料", eventName: EVENTNAMES["批量同步ERP资料到快麦通资料"] },
      ],
      visible: CheckPower(UserBtnPowerConsts.PROD_CENTER_BATCH_UPDATE_GOODS),
    },
    {
      text: "转为分销商品", eventName: EVENTNAMES["转为分销商品"], visible: CheckPower(UserBtnPowerConsts.PROD_CENTER_TO_DISTRIBUTION_GOODS),
    },
    // 库存上传
    {
      ...stockUploadDropdownList,
      visible: store.state.mixture.confModule.isStockUpload,
    },
    {
      text: "商品标签管理",
      eventName: EVENTNAMES["商品标签管理"],
    },
    {
      text: "门店商品",
      dropList: [
        { text: "推送门店商品", eventName: EVENTNAMES["推送门店商品"] },
        { text: "查看门店商品", eventName: EVENTNAMES["查看门店商品"] },
      ],
      tooltip: "仅适用于淘宝小时达，抖音即时零售",
    },
    {
      text: "抖店商品优化",
      dropList: [
        { text: "查询诊断商品", eventName: EVENTNAMES["查询诊断商品"] },
        { text: "AI托管中心", eventName: EVENTNAMES["AI托管中心"] },
      ],
      visible: store.getters.get_AllShops_BySource('fxg')?.length > 0,
    },
  ];

  return btnList.filter(it => {
    if (it.visible === false) {
      return false;
    } else {
      if (it.dropList) {
        it.dropList = it.dropList.filter(item => item.visible !== false);
      }
      return true;
    }
  });
}

export const SUPPLIER_BTNS_LIST = () => {
  const UserBtnPowerConsts = store.getters.userBtnPowerConsts;
  const hasPublishPower = CheckPower(UserBtnPowerConsts.PROD_CENTER_PUBLIC_GOODS);
  let btnList = [
    { text: "批量铺货", eventName: EVENTNAMES["批量铺货"], visible: hasPublishPower },
    {
      text: "更新铺货",
      eventName: EVENTNAMES["更新铺货"],
      tooltip: "用于更新平台店铺已有的商品信息",
      visible: hasPublishPower,
    },
    {
      text: "组合铺货",
      dropList: [
        { text: "直接组合铺货", eventName: EVENTNAMES["直接组合铺货"], tooltip: "用于将多个商品组合上架到一个款上面", visible: hasPublishPower },
        { text: "加入购物车后铺货", eventName: EVENTNAMES["加入购物车后铺货"], tooltip: "将商品加入购物车后再进行组合铺货，支持跨页选款", visible: hasPublishPower },
      ],
      visible: hasPublishPower,
    },
    {
      text: "AI生成资料",
      dropList: [
        { text: "生成抖音资料", eventName: EVENTNAMES["一键生成平台资料"], config: { platform: 'fxg' }},
        { text: "生成1688资料", eventName: EVENTNAMES["一键生成平台资料"], config: { platform: '1688' } },
        { text: "生成拼多多资料", eventName: EVENTNAMES["一键生成平台资料"], config: { platform: 'pdd' } },
        { text: "生成淘宝资料", eventName: EVENTNAMES["一键生成平台资料"], config: { platform: 'tb' } },
        { text: "生成快手资料", eventName: EVENTNAMES["一键生成平台资料"], config: { platform: 'kuaishou' } },
        { text: "生成天猫资料", eventName: EVENTNAMES["一键生成平台资料"], config: { platform: 'tm' } },
        { text: "生成微信小店（视频号）资料", eventName: EVENTNAMES["一键生成平台资料"], config: { platform: 'wxsph' } },
        { text: "生成京东资料", eventName: EVENTNAMES["一键生成平台资料"], config: { platform: 'jd' } },
        { text: "生成小红书资料", eventName: EVENTNAMES["一键生成平台资料"], config: { platform: 'xhs' } },
        { text: "生成闲鱼资料", eventName: EVENTNAMES["一键生成平台资料"], config: { platform: 'xy' } },
        { text: "生成Temu资料", eventName: EVENTNAMES["一键生成平台资料"], config: { platform: 'pddtemu' } },
      ],
    },
    {
      text: "批量下架",
      eventName: EVENTNAMES["批量下架"],
      // tooltip: "用于将多个商品组合上架到一个款上面",
      visible: CheckPower(UserBtnPowerConsts.PROD_CENTER_BATCH_DELISTING),
    },
    {
      text: "新增商品",
      dropList: [
        { text: "从平台店铺下载", eventName: EVENTNAMES["从平台店铺下载"] },
        { text: "从快麦ERP导入", eventName: EVENTNAMES["从快麦ERP导入"] },
        { text: "手工新增商品", eventName: EVENTNAMES["手工新增商品"] },
        // {text: 'excel导入商品', eventName: EVENTNAMES['excel导入商品']}
      ],
      visible: CheckPower(UserBtnPowerConsts.PROD_CENTER_ADD),
    },
    {
      text: "批量操作",
      dropList: [
        { text: "修改销售价", eventName: EVENTNAMES["修改销售价"] },
        { text: "修改市场价", eventName: EVENTNAMES["修改市场价"] },
        { text: "修改类目和属性", eventName: EVENTNAMES["修改类目和属性"] },
        { text: "修改库存", eventName: EVENTNAMES["修改库存"] },
        { text: "修改重量", eventName: EVENTNAMES["修改重量"] },
        { text: "修改商品名称", eventName: EVENTNAMES["修改商品名称"] },
        { text: "修改绑定关系", eventName: EVENTNAMES["修改绑定关系"], tooltip: '勾选商品，手动修改快麦通商品和ERP商品的关联关系' },
        { text: "读取对应表关系", eventName: EVENTNAMES["读取对应表关系"], tooltip: '勾选商品，从平台下载的快麦通商品，获取对应表的关联关系作为快麦通商品和ERP商品的关联关系' },
        { text: "批量设置商品标签", eventName: EVENTNAMES["批量设置商品标签"] },
        { text: "批量关联素材包", eventName: EVENTNAMES["批量关联素材包"] },
        { text: "批量解除关联", eventName: EVENTNAMES["批量解除关联"] },
        { text: "批量设置展架分类", eventName: EVENTNAMES["批量设置展架分类"]},
        { text: "批量设置退货地址", eventName: EVENTNAMES["批量设置退货地址"] },
        { text: "快捷创建分销商品规则", eventName: EVENTNAMES["快捷创建分销商品规则"], tooltip: '勾选商品，将商品绑定的ERP商品便捷创建一个分销商品规则' },
      ],
      visible: CheckPower(UserBtnPowerConsts.PROD_CENTER_EDIT),
    },
    {
      text: "加入到我的分销小店",
      dropList: [
        { text: "加入分销小店且所有人可见(公开)", eventName: EVENTNAMES["加入分销小店且所有人可见(公开)"] },
        { text: "加入分销小店仅分销商可见(私密)", eventName: EVENTNAMES["加入分销小店仅分销商可见(私密)"] },
        { text: "移出分销小店", eventName: EVENTNAMES["移出分销小店"] },
      ],
    },
    { text: "删除商品", eventName: EVENTNAMES["删除商品"], visible: CheckPower(UserBtnPowerConsts.PROD_CENTER_DELETE) },
    {
      text: "批量更新资料",
      dropList: [
        // CheckPower(BtnPowerConsts.BATCHSYNCTOERP) ? { text: "批量同步快麦通资料到ERP资料", eventName: EVENTNAMES["批量同步快麦通资料到ERP资料"] } : null,
        { text: "批量同步快麦通资料到ERP资料", eventName: EVENTNAMES["批量同步快麦通资料到ERP资料"] },
        { text: "批量同步ERP资料到快麦通资料", eventName: EVENTNAMES["批量同步ERP资料到快麦通资料"] },
      ],
      visible: CheckPower(UserBtnPowerConsts.PROD_CENTER_BATCH_UPDATE_GOODS),
    },
    {
      text: "同步商品分类",
      eventName: EVENTNAMES["同步商品分类"],
    },
    {
      text: "提报货源",
      eventName: EVENTNAMES["提报货源"],
    },
    {
      text: "商品标签管理",
      eventName: EVENTNAMES["商品标签管理"],
    },
    {
      text: "门店商品",
      dropList: [
        { text: "推送门店商品", eventName: EVENTNAMES["推送门店商品"] },
        { text: "查看门店商品", eventName: EVENTNAMES["查看门店商品"] },
      ],
      tooltip: "仅适用于淘宝小时达，抖音即时零售",
    },
    {
      text: "抖店商品优化",
      dropList: [
        { text: "查询诊断商品", eventName: EVENTNAMES["查询诊断商品"] },
        { text: "AI托管中心", eventName: EVENTNAMES["AI托管中心"] },
      ],
      visible: store.getters.get_AllShops_BySource('fxg')?.length > 0,
    },
  ];

  return btnList.filter(it => {
    if (it.visible === false) {
      return false;
    } else {
      if (it.dropList) {
        it.dropList = it.dropList.filter(item => item.visible !== false);
      }
      return true;
    }
  });
}

const prod_center_dictionary = {
  // 支持自动生成资料的平台
  FAST_CREATE_PLATFORMS: ['fxg', 'alibaba', 'pdd', 'tb', 'kuaishou', 'jd', 'wxsph', 'xhs', 'xy','pddtemu'],
  // 提报状态-日志
  PUT_STATUS: [
    { label: '提报成功', value: 2 },
    { label: '提报异常', value: 3 },
    { label: '审核中', value: 1 },
  ],
  // 提报状态-商品中心
  PUT_STATUS_CENTER: [
    { label: '全部', value: '' },
    { label: '未提报', value: 0 },
    { label: '审核中', value: 1 },
    { label: '提报成功', value: 2 },
    { label: '提报异常', value: 3 },
  ],
  // 提报状态-商品中心-表格配置
  PUT_STATUS_CENTER_List: [
    { label: '未提报货源', value: 0, bgColor:'#396CF3' },
    { label: '审核中', value: 1, bgColor:'#FD8944', width:'56px' },
    { label: '提报成功', value: 2, bgColor:'#029901', width:'68px'},
    { label: '提报异常', value: 3, bgColor:'red' },
  ],
  // 分销状态
  DISTRIBUTION_STATE: [
    { label: '可分销', value: 1 },
    { label: '不可分销', value: 2 },
    { label: '待完善', value: 0 },
  ],
  // 私密状态
  PRIVACY_STATE: [
    { label: '私密', value: 1 },
    { label: '公开', value: 0 }
  ],
  OUTER_ID_BLUR: [
    { label: '精确匹配', value: 0 },
    { label: '模糊匹配', value: 1 }
  ],
  // 
  IS_PRIVACY_DISTRIBUTION_STATE: [
    { label: '加入且公开(所有人可见)', value: 1 },
    { label: '加入且私密(仅分销商可见)', value: 2 },
    { label: '暂不加入', value: 3 },
  ],
  // 是否加入分销小店
  PRIVACY_DISTRIBUTION_STATE: [
    { label: '已加入且公开', value: 1 },
    { label: '已加入且私密', value: 2 },
    { label: '未加入', value: 3 },
  ],
  // 商品来源
  CREATE_SOURCE: [
    {label: '从快麦ERP导入', value: 'erp_import'},
    {label: '手工新增商品', value: 'manual_create'},
    // {label: 'excel导入商品', value: 'excel_import'}
    {label: '从平台店铺下载-抖音', value: 'fxg_download'},
    {label: '从平台店铺下载-快手', value: 'kuaishou_download'},
    {label: '从平台店铺下载-拼多多', value: 'pdd_download'},
    {label: '从平台店铺下载-京东', value: 'jd_download'},
    {label: '从平台店铺下载-淘宝', value: 'tb_download'},
    {label: '从平台店铺下载-天猫', value: 'tm_download'},
    {label: '从平台店铺下载-1688', value: '1688_download'},
    {label: '从平台店铺下载-有赞', value: 'youzan_download'},
    {label: '从平台店铺下载-微信视频号', value: 'wxsph_download'},
    {label: '从平台店铺下载-微信小店', value: 'wxxd_download'},
    {label: '从平台店铺下载-小红书', value: 'xhs_download'},
    {label: '从平台店铺下载-闲鱼', value: 'xy_download'},
    {label: '从平台店铺下载-Temu', value: 'pddtemu_download'},
    {label: '从平台店铺下载-Shein', value: 'shein_download'},
    {label: '从供销商导入', value: 'supplier_download'},
    {label: '复制快麦通商品', value: 'item_copy'},
  ],
  // 是否代发
  DROP_SHIPPING: [
    {label: '是', value: 1 },
    {label: '否', value: 0 }
  ],
  // 已经完善/未完善平台资料 支持类型
  PLATFORMDATA_TYPE:[
    {label: '包含全部', value: 1 },
    {label: '包含任一', value: 2 }
  ],

  // 商品来源英文对中文map
  CREATE_SOURCE_EN_CN: {
    "platform_download": "从平台店铺下载",
    "erp_import": "从快麦ERP导入",
    "manual_create": "手工新增商品",
    "excel_import": "excel导入商品",
    "fxg_download": "从平台店铺下载-抖音",
    "kuaishou_download": "从平台店铺下载-快手",
    "pdd_download": "从平台店铺下载-拼多多",
    "jd_download": "从平台店铺下载-京东",
    "tb_download": "从平台店铺下载-淘宝",
    "tm_download": "从平台店铺下载-天猫",
    "1688_download": "从平台店铺下载-1688",
    "youzan_download": "从平台店铺下载-有赞",
    "wxsph_download": "从平台店铺下载-微信视频号",
    "wxxd_download": "从平台店铺下载-微信小店",
    "xhs_download": "从平台店铺下载-小红书",
    "xy_download": "从平台店铺下载-闲鱼",
    "pddtemu_download": "从平台店铺下载-Temu",
    "shein_download": "从平台店铺下载-Shein",
    "supplier_download": "从供销商导入",
    "item_copy":"复制快麦通商品",
  },
  // 下载状态
  DOWNLOAD_STATUS: {
    0: '未下载',
    1: '已下载'
  },
  // 平台状态
  PLATFORM_STATUS:[ 
    { label: '全部', value: null },
    { label: '上架', value: '0' },
    { label: '下架', value: '1' },
  ],
  // 同步商品按钮文案
  SYNCSHOP_BTN_TEXT: {
    1: '同步商品',
    2: '同步中...'
  },
   // 商品铺货状态
   PUBLISH_STATUS: [
    { label: '铺货中', value: 0 },
    { label: '全部成功', value: 1 },
    { label: '全部失败', value: 2 },
    { label: '部分成功', value: 3 },
  ],
  PUT_STATUS_MAP:{
    1: "审核中",
    2: "提报成功",
    3: "提报异常"
  },
  PUBLISH_STATUS_MAP: {
    0: "铺货中",
    1: "全部成功",
    2: "全部失败",
    3: "部分成功"
  },
  // 新增商品状态
  NEW_PRODUCT_STATUS: [
    { label: '新增中', value: 0 },
    { label: '全部成功', value: 1 },
    { label: '全部失败', value: 2 },
    { label: '部分成功', value: 3 },
  ],
  UPDATE_PRODUCT_STATUS: [
    { label: '更新中', value: 0 },
    { label: '全部成功', value: 1 },
    { label: '全部失败', value: 2 },
    { label: '部分成功', value: 3 },
  ],
  NEW_PRODUCT_STATUS_MAP: {
    0: "新增中",
    1: "全部成功",
    2: "全部失败",
    3: "部分成功"
  },
  SHOP_OPT_STATUS_MAP: {
    1: "全部成功",
    2: "全部失败",
    3: "部分成功"
  },
  SHOP_OPT_STATUS: [
    { label: '全部成功', value: 1 },
    { label: '全部失败', value: 2 },
    { label: '部分成功', value: 3 },
  ],
  UPDATE_STATUS_MAP: {
    0: "铺货中",
    1: "全部成功",
    2: "全部失败",
    3: "部分成功"
  },
  OFF_SALE_STATUS_MAP: {
    0: "下架中",
    1: "全部成功",
    2: "全部失败",
    3: "部分成功"
  },
  // 小店导入状态，但其实也是分销状态
  IMPORT_STATE: [
    { label: '已导入', value: 1 },
    { label: '未导入', value: 0 },
  ],
   // 是否分销
  IS_DISTRIBUTIONS: [
    { label: '是', value: 1 },
    { label: '否', value: 0 },
  ],
  // 是否关联ERP资料
  IS_DISTRIBUTIONS_ERP: [
    { label: '是', value: 1 },
    { label: '否', value: 0 },
  ],
  HAS_FOLDER: [
    { label: '未关联', value: 0 },
    { label: '已关联，允许分销商下载', value: 1 },
    { label: '已关联，不允许分销商下载', value: 2 },
  ],
  // 自动铺货规则状态
  IS_AUTO_PUBLISH_RULE_STATUS: [
    { label: '启用', value: 1 },
    { label: '禁用', value: 0 },
  ],
  // 操作类型
  OPERATION_TYPE:[
    { label: '上架', value: 80003 },
    { label: '下架', value: 80004 },
    { label: '同步店铺商品', value: 10022 },
    { label: '批量修改主图', value: 80007 },
    { label: '店铺价格修改', value: 80005 },
    { label: '批量改标题', value: 80006 },
    { label: '店铺商品资料修改', value: 80008 },
    { label: '快速铺货', value: 80009 },
    { label: '批量删除', value: 10025 },
    { label: '批量修改商品发货时效', value: 80013 },
  ]
}

export default prod_center_dictionary